<template>
    <div>
        <el-form
                ref="form"
                :model="form"
                :rules="rules"
                v-loading="isBusy"
                element-loading-spinner="el-icon-loading"
                label-width="170px"
        >
            <el-form-item label="Name" prop="name">
                <el-input v-model="form.name" placeholder="Name"></el-input>
            </el-form-item>
            <el-form-item label="Message" prop="message">
                <el-input
                        type="textarea"
                        ref="message"
                        v-model="form.message"
                        :autosize="{minRows: 4, maxRows: 8}"
                        placeholder="Message"
                        class="message-input"
                ></el-input>
                <message-tools @insert-value="insertValueIntoMessage"></message-tools>
            </el-form-item>
            <el-form-item prop="min_interval">
                <template v-slot:label>
                    <el-tooltip
                            effect="light"
                            content="Minimal interval since the last contact in days"
                            placement="top-start"
                    >
                        <span>Minimal Interval <i class="far fa-question-circle"></i></span>
                    </el-tooltip>
                </template>
                <min-interval-select
                        class="w-100"
                        v-model="form.min_interval"
                        placeholder="Time since last contact"
                ></min-interval-select>
            </el-form-item>
            <el-form-item prop="max_messages">
                <template v-slot:label>
                    <el-tooltip
                            effect="light"
                            content="Send Messages Limit"
                            placement="top-start"
                    >
                        <span>Send Limit <i class="far fa-question-circle"></i></span>
                    </el-tooltip>
                </template>
                <el-input v-model="form.max_messages" placeholder="Send Messages Limit"></el-input>
            </el-form-item>
        </el-form>
        <button class="btn btn-create px-4" @click="store">Store</button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import InputMixin from '../../mixins/inputs';
  import MessageTools from '../shared/message-tools';
  import MinIntervalSelect from '../shared/inputs/min-interval-select';
  import {isParsableNumber} from "../../helpers";

  export default {
    extends: BaseForm,

    components: {
      MessageTools,
      MinIntervalSelect,
    },

    mixins: [
      InputMixin,
    ],

    data() {
      const form = {
        name: null,
        message: null,
        min_interval: null,
        max_messages: null
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      }
    },
    methods: {
      /**
       * @param {Object} model
       */
      initForm(model) {
        const form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
        const overrides = {
          body: this.clearStr(_.get(model, 'message', '') || ''),
          min_interval: this.secondsToDays(_.get(model, 'min_interval', null)),
        };

        this.form = _.defaults(overrides, form);
      },

      /**
       * @param {string} val
       * @return {string}
       */
      clearStr(val) {
        val = String(val).trimEnd();

        return val ? val.replace(/\r\n/g, "\n") : val;
      },

      /**
       * @return {number|undefined}
       */
      secondsToDays(value) {
        if (_.isFinite(value)) {
          return _.floor(moment.duration(value, 'seconds').asDays());
        }
      },

      /**
       * @return {Object}
       */
      getForm() {
        return _.assign({}, this.form, {
          _method: this.method,
          min_interval: this.daysToSeconds(this.form.min_interval),
        });
      },

      /**
       * @return {number|null}
       */
      daysToSeconds(value) {
        if (isParsableNumber(value)) {
          return moment.duration(Number(value), 'days').asSeconds();
        }

        return value;
      },

      /**
       * @param {string} value
       */
      insertValueIntoMessage(value) {
        this.addTextInCursorPosition(
          _.get(this.$refs, 'message.$refs.textarea'),
          _.toString(this.form.message),
          value,
          this.messageSetter
        );
      },

      /**
       * @param {string} value
       */
      messageSetter(value) {
        this.form.message = value;
      }
    }
  }
</script>

